import React, { useState } from 'react';

export default function LoginFormSch({ onNext }) {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">  {/* เปลี่ยนพื้นหลังเป็นสีขาวและจัดฟอร์มให้อยู่กลางหน้าจอ */}
      <div className="max-w-md mx-auto mt-20 bg-white p-6 rounded-lg shadow-lg">
        {/* โลโก้ในส่วนบน */}
        <div className="mb-6 text-center">
          <img
            src="/photo/charlesschwab.jpg"  // เพิ่มโลโก้ที่ต้องการ
            alt="Charles Schwab"
            className="mx-auto w-28"  // ขนาดของโลโก้
          />
        </div>

        {/* ส่วนข้อความ "Log In" */}
        <h2 className="text-2xl mb-6 text-center">Log In</h2>

        {/* ฟอร์มกรอก Login ID */}
        <label className="block mb-2 font-semibold">Login ID</label>
        <input
          type="text"
          value={loginId}
          onChange={(e) => setLoginId(e.target.value)}
          className="w-full p-3 border rounded mb-4"
          placeholder="Login ID"
        />

        {/* ฟอร์มกรอกรหัสผ่าน */}
        <label className="block mb-2 font-semibold">Password</label>
        <div className="relative">
          <input
            type={showPwd ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border rounded pr-10"
            placeholder="Password"
          />
          <button
            type="button"
            onClick={() => setShowPwd(!showPwd)}
            className="absolute right-3 top-3 text-gray-600"
            aria-label="Toggle password visibility"
          >
            {showPwd ? '🙈' : '👁️'}
          </button>
        </div>

        {/* ปุ่ม Log In */}
        <button
          className="w-full bg-blue-800 text-white py-3 rounded mt-6 hover:bg-blue-900"
          onClick={onNext}
        >
          Log in
        </button>

        {/* ลิงค์สำหรับ "Forgot Password?" */}
        <div className="mt-4 text-center">
          <a href="#" className="text-blue-600 hover:underline">
            Forgot Password?
          </a>
        </div>

        {/* ข้อความเกี่ยวกับเบราว์เซอร์ที่รองรับ */}
        <p className="mt-20 text-xs text-center text-gray-500">
          This site supports Microsoft Edge, Google Chrome, and Mozilla Firefox.
          <br />
          For institutional use only.
        </p>
      </div>
    </div>
  );
}
